import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import { toOracleDate } from '@/lib/dateUtils';
import type {
  UpdateCameraOwnerRequest,
  CameraArchiveDepth,
  UpdateCameraTariffRequest,
  UpdateCameraTariffResponse,
  UpdateCameraDiscountRequest,
  UpdateCameraStatusRequest,
  CameraHistory,
} from './types';

export async function updateCameraOwner(
  idCamera: string,
  body: UpdateCameraOwnerRequest
): Promise<number> {
  const { data } = await apiClient.put<ApiResponse<number>>(`/api/cameras/${idCamera}/owner`, body);
  if (!data.success) throw new Error('Не удалось передать камеру');
  return data.response ?? 0;
}

export async function fetchCameraArchiveDepth(
  isOnlyActive: '0' | '1' = '1'
): Promise<CameraArchiveDepth[]> {
  const { data } = await apiClient.get<ApiResponse<CameraArchiveDepth[]>>(
    `/api/cameras/archive-depth/${isOnlyActive}`
  );
  if (!data.success) throw new Error('Не удалось загрузить глубины архива');
  return data.response ?? [];
}

export async function updateCameraTariff(
  idCamera: string,
  idTariff: string,
  body: UpdateCameraTariffRequest
): Promise<UpdateCameraTariffResponse> {
  const { data } = await apiClient.put<ApiResponse<UpdateCameraTariffResponse>>(
    `/api/cameras/${idCamera}/tariff/${idTariff}`,
    { ...body, date: body.date ? toOracleDate(body.date) : undefined }
  );
  if (!data.success) throw new Error('Не удалось сменить тариф');
  return data.response ?? { result: '', message: '', remain_pay: 0 };
}

export async function updateCameraDiscount(
  idCamera: string,
  body: UpdateCameraDiscountRequest
): Promise<void> {
  const { data } = await apiClient.put<ApiResponse<unknown>>(`/api/cameras/${idCamera}/discount`, {
    ...body,
    date: body.date ? toOracleDate(body.date) : undefined,
  });
  if (!data.success) throw new Error('Не удалось обновить скидку');
}

export async function fetchCameraHistory(idCamera: string): Promise<CameraHistory[]> {
  const { data } = await apiClient.get<ApiResponse<CameraHistory[]>>(
    `/api/cameras/${idCamera}/history`
  );
  if (!data.success) throw new Error('Не удалось загрузить историю камеры');
  return data.response ?? [];
}

export async function updateCameraStatus(
  idCamera: string,
  body: UpdateCameraStatusRequest
): Promise<void> {
  const { data } = await apiClient.put<ApiResponse<unknown>>(`/api/cameras/${idCamera}/status`, {
    ...body,
    date: body.date ? toOracleDate(body.date) : undefined,
  });
  if (!data.success) throw new Error('Не удалось изменить статус камеры');
}
